import script from "./Record2ChSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./Record2ChSetting.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__